module.exports = __webpack_public_path__ + "img/QRCodeLogo.9a6d9260.png";